export default "__VITE_ASSET__C7IUJlO1__"